// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearMonitorMobile = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10 17.7H6.21C2.41 17.7 1.25 16.54 1.25 12.74V6.74003C1.25 2.94003 2.41 1.78003 6.21 1.78003H16.74C20.54 1.78003 21.7 2.94003 21.7 6.74003C21.7 7.15003 21.36 7.49003 20.95 7.49003C20.54 7.49003 20.2 7.15003 20.2 6.74003C20.2 3.80003 19.68 3.28003 16.74 3.28003H6.21C3.27 3.28003 2.75 3.80003 2.75 6.74003V12.74C2.75 15.68 3.27 16.2 6.21 16.2H10C10.41 16.2 10.75 16.54 10.75 16.95C10.75 17.36 10.41 17.7 10 17.7Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10 22.2199C9.59 22.2199 9.25 21.8799 9.25 21.4699V16.9399C9.25 16.5299 9.59 16.1899 10 16.1899C10.41 16.1899 10.75 16.5299 10.75 16.9399V21.4699C10.75 21.8899 10.41 22.2199 10 22.2199Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10 13.7H2C1.59 13.7 1.25 13.36 1.25 12.95C1.25 12.54 1.59 12.2 2 12.2H10C10.41 12.2 10.75 12.54 10.75 12.95C10.75 13.36 10.41 13.7 10 13.7Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.0002 22.22H6.74023C6.33023 22.22 5.99023 21.88 5.99023 21.47C5.99023 21.06 6.33023 20.72 6.74023 20.72H10.0002C10.4102 20.72 10.7502 21.06 10.7502 21.47C10.7502 21.88 10.4102 22.22 10.0002 22.22Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.0403 22.2201H15.4903C12.7203 22.2201 11.7803 21.2801 11.7803 18.5101V12.8001C11.7803 10.0301 12.7203 9.09009 15.4903 9.09009H19.0403C21.8103 9.09009 22.7503 10.0301 22.7503 12.8001V18.5101C22.7503 21.2901 21.8103 22.2201 19.0403 22.2201ZM15.4903 10.5901C13.5303 10.5901 13.2803 10.8401 13.2803 12.8001V18.5101C13.2803 20.4701 13.5303 20.7201 15.4903 20.7201H19.0403C21.0003 20.7201 21.2503 20.4701 21.2503 18.5101V12.8001C21.2503 10.8401 21.0003 10.5901 19.0403 10.5901H15.4903Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17.2998 18.97C17.0398 18.97 16.7798 18.87 16.5898 18.68C16.4998 18.59 16.4298 18.48 16.3798 18.36C16.3298 18.23 16.2998 18.1 16.2998 17.97C16.2998 17.71 16.4098 17.45 16.5898 17.27C16.8198 17.04 17.1698 16.93 17.4998 16.99C17.5598 17.01 17.6198 17.03 17.6798 17.05C17.7398 17.08 17.7998 17.11 17.8498 17.14C17.9098 17.18 17.9598 17.22 18.0098 17.27C18.1898 17.45 18.2998 17.71 18.2998 17.97C18.2998 18.1 18.2698 18.23 18.2198 18.36C18.1698 18.48 18.0998 18.59 18.0098 18.68C17.9598 18.73 17.9098 18.77 17.8498 18.8C17.7998 18.84 17.7398 18.87 17.6798 18.9C17.6198 18.92 17.5598 18.94 17.4998 18.95C17.4298 18.97 17.3698 18.97 17.2998 18.97Z',
      fill: 'currentColor',
    }),
  );

export { IconLinearMonitorMobile };
